import { LocationCard } from "../../../../Locations/shared/LocationCard.js";
import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Location/Display.tsx
var LocationFieldDisplay = ({ config }) => {
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	const value = valuesByFieldId[config.id];
	if (!value) return null;
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [/* @__PURE__ */ jsxs(Label, { children: [config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {}), config.options.displayLabel] }), /* @__PURE__ */ jsx("div", { children: Array.isArray(value) ? value.map((locationId) => /* @__PURE__ */ jsx("div", {
				className: "gap-xs pr-xs inline-flex flex-wrap",
				children: /* @__PURE__ */ jsx(LocationCard, { locationId }, locationId)
			}, locationId)) : /* @__PURE__ */ jsx("div", {
				className: "inline-flex",
				children: /* @__PURE__ */ jsx(LocationCard, { locationId: value })
			}) })]
		})
	});
};
//#endregion
export { LocationFieldDisplay };

//# sourceMappingURL=Display.js.map